import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert } from '../../../common/icons';
import styles from './style.scss';

const ValidationTopErrorMessage = ({errorMessage, className, style}) => {

    return(
        <div
            data-cy='validation-error-message'
            style={style} 
            className={classNames(styles.formValidationMessageWrapper,
                className && className,
                (errorMessage == null || errorMessage && styles.show))}>
            <span className={classNames(styles.errorMessage)}>
                <Alert />{' '}
                <span>
                    {errorMessage}
                </span>
            </span>
        </div>
    );
}

ValidationTopErrorMessage.protoType = {
    errorMessage: PropTypes.string
};

export default ValidationTopErrorMessage;


// WEBPACK FOOTER //
// ./src/components/portal/controls/validationTopErrorMessage/index.jsx